<template>
  <section v-if="revisionConflicts.length > 0" data-cy="conflict-resolver-section">
    <h2>Fix Update Conflict</h2>
    <hr />
    <div v-for="conflict in revisionConflicts" :key="conflict.operation.key">
      <div class="grid text-center">
        <div class="col-12 md:col-6">
          <h3>Pending Update</h3>
          <ul class="text-left" data-cy="pending-updates-list">
            <li v-for="(value, key) in conflict.diff?.new" :key="key">
              <b>{{ key }}:</b> {{ value }}
            </li>
          </ul>
          <Button
            label="Save Pending Update"
            class="p-button-sm"
            @click="fastForwardRevision(conflict)"
            data-cy="save-pending-update-btn"
          />
        </div>
        <div class="col-12 md:col-6">
          <h3>Current Saved Item</h3>
          <ul class="text-left" data-cy="current-saved-items-list">
            <li v-for="(value, key) in conflict.diff?.old" :key="key">
              <b>{{ key }}:</b> {{ value }}
            </li>
          </ul>
          <Button
            label="Discard Pending Update"
            class="p-button-sm"
            @click="discardRevision(conflict)"
            data-cy="discard-pending-update-btn"
          />
        </div>
      </div>
      <hr />
    </div>
  </section>
</template>


<script setup lang="ts">
import { useConflictRevisions } from "@/composables/conflict/revisions";
import { useClientHandle } from "@urql/vue";

const handle = useClientHandle();

const {
  revisionConflicts,
  discardRevision,
  fastForwardRevision
} = useConflictRevisions({ handle });
</script>

<style scoped></style>
